import { type BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { type SocietyWorkflowBodyInput } from "shared/api/types/society/[societyId]/workflow";
import { type SocietyWorkflowParamsInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]";
import { type WorkflowView } from "shared/mappers/database/workflow/workflow";
export const postSocietyWorkflowIdContract: BaseApiContract<
  SocietyWorkflowParamsInput,
  SocietyWorkflowBodyInput,
  WorkflowView
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/workflow/[workflowId]",
  paramsType: {} as SocietyWorkflowParamsInput,
  bodyType: {} as SocietyWorkflowBodyInput,
  responseType: {} as WorkflowView,
};
export const getSocietyWorkflowIdContract: BaseApiContract<
  SocietyWorkflowParamsInput,
  undefined,
  WorkflowView
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/workflow/[workflowId]",
  paramsType: {} as SocietyWorkflowParamsInput,
  responseType: {} as WorkflowView,
};
export const deleteSocietyWorkflowIdContract: BaseApiContract<
  SocietyWorkflowParamsInput,
  undefined,
  void
> = {
  method: HttpMethod.DELETE,
  apiRoute: "/api/v1/society/[societyId]/workflow/[workflowId]",
  paramsType: {} as SocietyWorkflowParamsInput,
  responseType: undefined as unknown as void,
};
